import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { TipoProducto } from '@/types/tipoProducto.model';

interface TipoProductoDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  tipoProducto?: TipoProducto;
}

const TipoProductoDetailModal = ({ isOpen, onClose, tipoProducto }: TipoProductoDetailModalProps) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
      size="2xl"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Detalle de Tipo de Producto</ModalHeader>
            <ModalBody className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                  <p className="text-gray-900">{tipoProducto?.nombre || '-'}</p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                  <p className="text-gray-900">{tipoProducto?.descripcion || '-'}</p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Creación</label>
                  <p className="text-gray-900">{tipoProducto?.createdAt ? new Date(tipoProducto.createdAt).toLocaleDateString() : '-'}</p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Actualización</label>
                  <p className="text-gray-900">{tipoProducto?.updatedAt ? new Date(tipoProducto.updatedAt).toLocaleDateString() : '-'}</p>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="primary" 
                variant="light"
                onPress={onClose}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default TipoProductoDetailModal;